import { Droplets, Sprout, Sun } from "lucide-react";
import GlassCard from "@/components/GlassCard";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const PlantActionCard = ({ plant, onMarkWatered, onClick }) => {
    if (!plant) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const nextWater = new Date(plant.next_watering_at);
    nextWater.setHours(0, 0, 0, 0);
    const isOverdue = nextWater <= today;

    return (
        <div
            onClick={onClick}
            className="w-full text-left cursor-pointer transition-transform active:scale-[0.98]"
        >
            <GlassCard className="p-4 relative overflow-hidden">
                {/* Visual indicator for overdue */}
                {isOverdue && (
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-red-500" />
                )}

                <div className="flex items-start gap-4">
                    <div className={cn(
                        "p-2 rounded-xl shrink-0",
                        isOverdue ? "bg-red-500/10" : "bg-emerald-500/10"
                    )}>
                        <Sprout className={cn(
                            "w-5 h-5",
                            isOverdue ? "text-red-500" : "text-emerald-600"
                        )} />
                    </div>

                    <div className="flex-1 min-w-0 flex justify-between items-center">
                        <div className="min-w-0">
                            <h3 className="font-bold text-foreground">
                                Water {plant.name}
                            </h3>
                        </div>

                        <Button
                            size="sm"
                            variant="ghost"
                            className={cn(
                                "h-8 rounded-lg transition-all text-xs font-bold px-3 ml-2 shrink-0",
                                isOverdue
                                    ? "bg-red-500/10 text-red-500 hover:bg-red-500 hover:text-white"
                                    : "bg-emerald-500/10 text-emerald-600 hover:bg-emerald-500 hover:text-white"
                            )}
                            onClick={(e) => {
                                e.stopPropagation();
                                onMarkWatered(plant.id);
                            }}
                        >
                            <Droplets className="w-3.5 h-3.5 mr-1.5" />
                            Mark Watered
                        </Button>
                    </div>
                </div>
            </GlassCard>
        </div>
    );
};

export default PlantActionCard;
